import * as React from 'react';
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid';
import { Button, Tooltip, IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { FileDownloadOutlined } from '@mui/icons-material';
import { exportToExcel } from '../../../Utility/Utilitys';

export default function PrintToolbar({ rows = [] }) {
  const apiRef = useGridApiContext();

  // 🔹 Print using MUI DataGrid’s built-in export
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint({
      hideFooter: true,
      hideToolbar: true,
      getRowsToExport: () => apiRef.current.getAllRowIds()
    });
  };

  // 🔹 Export to Excel
  const handleExport = () => {
    exportToExcel(rows, 'mis-report', 'MIS');
  };

  return (
    <GridToolbarContainer sx={{ justifyContent: 'flex-end', pr: 2 }}>
      <Tooltip title="Export to Excel">
        <IconButton color="primary" onClick={handleExport}>
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>

      <Tooltip title="Print">
        <IconButton color="primary" onClick={handlePrint}>
          <PrintIcon />
        </IconButton>
      </Tooltip>
    </GridToolbarContainer>
  );
}
